import { IUpdateRawQueryList } from '@models/Update.model';
import { UpdatesNewQuery } from './UpdatesNew.query';

interface IUpdatesNew {
  data: IUpdateRawQueryList[];
  isLoading: boolean;
  isError: boolean;
  hasMore?: boolean;
  loadMore: () => void;
}

const UpdatesNew = ({
  data,
  isLoading,
  isError,
  loadMore,
  hasMore,
}: IUpdatesNew) => {
  return (
    <UpdatesNewQuery
      data={data}
      isLoading={isLoading}
      isError={isError}
      loadMore={loadMore}
      hasMore={hasMore}
    />
  );
};

export { UpdatesNew };
